var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Erweima"},[_c('img',{attrs:{"src":_vm.xiaofang}}),_c('p',[_vm._v("扫描关注富邦智慧消防服务号")])])}
var staticRenderFns = []

export { render, staticRenderFns }